import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const ViewOrgPageContainerWrapperLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "ViewOrgPage" */
      './ViewOrgPageContainerWrapper.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
